const refreshPage = () => {
  window.location.reload();
  window.scrollTo(0, 0);
};

export default refreshPage;
